import Swiper from 'swiper';
import { A11y, Navigation, FreeMode, Pagination } from 'swiper/modules';
import { updateSlideAccessibility } from '../components/common/carousel';

const productsSlidersList = document.querySelectorAll('.swiper-products-slider');

document.addEventListener('DOMContentLoaded', () => {
  if (productsSlidersList.length > 0) {
    mountSlidersByElementsList(productsSlidersList);
  }
});

const mountSlidersByElementsList = nodeList => {
  nodeList.forEach(element => {
    const slides = element.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const hasSwiper = !!element.swiperInstance;

    if (slideCount < 2) {
      if (hasSwiper) {
        element.swiperInstance.destroy(true, true);
        element.swiperInstance = null;
      }
      element.classList.add('swiper-disabled');
      if (slideCount < 2) element.classList.add('swiper-disabled-single');
      return;
    }

    if (slideCount === 2) {
      element.classList.add('two-slides');
    }

    if (hasSwiper) return;

    element.classList.remove('swiper-disabled', 'swiper-disabled-single');

    const swiper = new Swiper(element, {
      modules: [Navigation, A11y, FreeMode, Pagination],
      slidesPerView: 1,
      slideToClickedSlide: true,
      loop: element.classList.contains('loop'),
      navigation: false,
      centeredSlides: true,
      spaceBetween: 16,
      autoplay: element.classList.contains('autoplay'),
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        700: {
          slidesPerView: 'auto',
        },
        1440: {
          spaceBetween: 0,
          centeredSlides: false,
          slidesPerView: 2,
        },
      },
      on: {
        init() {
          updateSlideAccessibility(this);
          setSwiperPaginationHidden(this);
        },
        slideChange() {
          updateSlideAccessibility(this);
          moveFocusToFirstVisibleElement(this);
          setSwiperPaginationHidden(this);
        },
        resize() {
          updateSlideAccessibility(this);
        },
      },
    });
    element.swiperInstance = swiper;
  });
};

function moveFocusToFirstVisibleElement(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];

  if (!activeSlide || activeSlide.getAttribute('aria-hidden') === 'true') return;

  const focusable = activeSlide.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

  if (focusable) {
    focusable.focus({ preventScroll: true });
  }
}

function setSwiperPaginationHidden(swiper) {
  requestAnimationFrame(() => {
    const bullets = swiper.pagination?.el?.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets) return;

    bullets.forEach(bullet => {
      bullet.setAttribute('tabindex', '-1');
    });
  });
}
